#import "../../../../../../common/graphql/NotesEntityFields.graphql"

query BatchNotesView($id: UUID!) {
  batchTransaction(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
